module.exports = __webpack_public_path__ + "static/iso-a0c2980ccc6aacfa29e3223e30269292.svg";